import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

// NOTE: Import any plugins initialization here.

ReactDOM.render(<App />, document.getElementById('root'));
